export default {
  inbox: {
    title: 'Bandeja de entrada',
    pending: 'Pendientes de Tratar',
    treated: 'Tratadas'
  },
  outbox: {
    title: 'Bandeja de salida',
    pending: 'Pendientes de Enviar',
    sent: 'Enviadas',
    accepted: 'Aceptadas',
    rejected: 'Rechazadas'
  },
  start: 'Inicio',
  search: 'Buscador',
  stored: 'Facturas Almacenadas',
  rioja: {
    queryProcedure: 'Ver fecha prevista de pago',
    queryThirdparty: 'Ver ficha de terceros'
  },
  sii: {
    title: 'SII',
    lrfe: 'LRFE'
  }
}
